import { Socket } from 'ngx-socket-io';
import { AuthService } from '@core/services/auth/auth.service';
import { Injectable } from '@angular/core';
import { environment } from '../../../../../environments/environment';
import { BehaviorSubject } from 'rxjs';
import { NotificationsModel } from '@shared/models/notifications.model';

@Injectable()
export class NotificationSocket extends Socket {
  public notification$: BehaviorSubject<NotificationsModel[]> =
    new BehaviorSubject<NotificationsModel[]>([]);

  constructor(private authService: AuthService) {
    super({
      url: `${environment.socketUrl}/notification_gateway`,
      options: { path: '/websocket', autoConnect: false },
    });
    // const token = this.authService.getAuthData().access_token;

    // this.ioSocket['auth'] = { token };
  }
}
